import axios from 'axios';
import axiosCancel from 'axios-cancel';
import ih from 'immutability-helper';
import { getToken } from 'store/services/session/selectors';
import store from 'store';
import _get from 'lodash/get';

export default class Common {
  defaultReqInterceptorHandler = config => {
    const token = getToken(store.getState());

    return token
      ? ih(config, { headers: { Authorization: { $set: `Token ${token}` } } })
      : config;
  };

  defaultResInterceptorErrorHandler = error => {
    const message = _get(error, 'response.data.error_message', error.message);
    const status = _get(error, 'response.status', 400);

    console.log('Message: ', message);
    console.log('Status: ', status);
  };

  constructor(
    config = {},
    incomingHandlers = { reqInterceptor: null, resErrorInterceptor: null },
  ) {
    // We place underscore by convention in front of private class properties
    this._axiosInstance = axios.create({
      timeout: 20000,
      baseURL: '/api/',
      ...config,
    });

    axiosCancel(this._axiosInstance, {
      debug: false, // default
    });

    // Interceptors
    // Common class provides a default interceptor handler but also calls
    // incoming interceptor handler from props in order to be able
    // to use this class as base class and provide more interceptors from
    // parent class.

    // Add request interceptor
    this._axiosInstance.interceptors.request.use(
      config => {
        let updatedConfig = this.defaultReqInterceptorHandler(config);

        if (incomingHandlers.reqInterceptor) {
          updatedConfig = incomingHandlers.reqInterceptor(updatedConfig);
        }
        return updatedConfig;
      },
      error => Promise.reject(error),
    );

    // Add response interceptor
    this._axiosInstance.interceptors.response.use(
      response => response,
      error => {
        this.defaultResInterceptorErrorHandler(error);
        if (incomingHandlers.resErrorInterceptor)
          incomingHandlers.resErrorInterceptor(error);

        throw error;
      },
    );
  }

  get axiosInstance() {
    return this._axiosInstance;
  }
}
